import {
  API_ENTRY_POINT,
  GET_CURRENCY,
  GROUP_BY_CONTINENT,
  STORAGE_EXPIRATION,
  LOCALSTORAGE_CURRENCY_NAME,
  SET_CURRENCY_MANUAL,
  CURRENCY_CODE_PARAM,
  API_KEY,
} from "../common/constants";
import { fetchAbstract } from "../common/utils";
import { StorageService } from "../../storage";

export class PosCurrency {
  constructor() {
    if (PosCurrency._instance) {
      return PosCurrency._instance;
    }
    this.formattedData = {
      currencies: [],
    };
    this.apiKey = null;
    this.apiEntryPoint = null;
    this.session = StorageService.getInstance();
    PosCurrency._instance = this;
  }

  async getCurrency() {
    try {
      const sessionData = this.session.get(LOCALSTORAGE_CURRENCY_NAME);
      if (sessionData) {
        return sessionData;
      }
      const rawData = await fetchAbstract(
        `${this.apiEntryPoint || API_ENTRY_POINT}/${GET_CURRENCY}?${GROUP_BY_CONTINENT}=true`,
        this.apiKey || API_KEY
      );
      this.formatData(rawData);
      this.formattedData["currencies"] = rawData;
      const expiration = new Date().getTime() + STORAGE_EXPIRATION;
      this.session.set(
        LOCALSTORAGE_CURRENCY_NAME,
        this.formattedData,
        expiration
      );
      return this.formattedData;
    } catch (error) {
      throw new Error(`An error occured in getCurrency func : ${error}`);
    }
  }

  formatData(rawData) {
    if (!rawData) {
      throw new TypeError(
        "Func formatData : rawdata argument was not provided"
      );
    }
    rawData.forEach((element) => {
      delete Object.assign(element, { ["value"]: element["continentCode"] })[
        "continentCode"
      ];
      delete Object.assign(element, { ["text"]: element["continentLabel"] })[
        "continentLabel"
      ];
      delete Object.assign(element, { ["options"]: element["currencyList"] })[
        "currencyList"
      ];
      element.attributes = [{ "data-id": element.value }];
      element.options.forEach((currency) => {
        delete currency.accorCountryCode;
        delete currency.isoCountryCode;
        currency.text = currency.currencyCode + " - " + currency.currencyLabel;
        currency.value = currency.currencyCode;
        currency.attributes = [
          {
            "data-continent": element.value,
            "data-currency": currency.value,
          },
        ];
      });
    });
  }

  async updateCurrency(currencyCode) {
    if (!currencyCode) {
      throw new TypeError(
        "updateCurrency :: param currencyCode was not provided"
      );
    }
    try {
      return await fetchAbstract(
        `${this.apiEntryPoint || API_ENTRY_POINT}${SET_CURRENCY_MANUAL}?${CURRENCY_CODE_PARAM}=${currencyCode}`,
        this.apiKey || API_KEY
      );
    } catch (error) {
      throw new Error(`An error occured in updateCurrency func :: ${error}`);
    }
  }

  async getContinentFromCurrency(currency) {
    if (!currency) {
      throw new TypeError(
        "getContinentFromCurrency :: param currency was not provided"
      );
    }

    try {
      let data = this.formattedData;
      let continentObject = null;
      if (!data.currencies.length) {
        const { currencies } = await this.getCurrency();
        data.currencies = currencies;
      }
      for (const continentCurrencies of data.currencies) {
        const currencyInContinent = continentCurrencies.options.find(
          (curr) => curr.value === currency
        );
        if (currencyInContinent) {
          continentObject = {
            continent: continentCurrencies.value,
            currencyCode: currencyInContinent.currencyCode,
            currencyLabel: currencyInContinent.currencyLabel,
            currencySymbol: currencyInContinent.currencySymbol,
          };
          break;
        }
      }
      return continentObject;
    } catch (error) {
      throw new Error(
        `getContinentFromCurrency :: an error occured => ${error}`
      );
    }
  }

  static getInstance() {
    return PosCurrency._instance || new PosCurrency();
  }
}
